import React from 'react';
import { HelpCircle, Heart, ShieldCheck } from 'lucide-react';
export function ProblemSection() {
  const cards = [{
    icon: <HelpCircle className="w-6 h-6 text-azul" data-id="element-179" />,
    text: 'No sabes qué hacer primero'
  }, {
    icon: <Heart className="w-6 h-6 text-azul" data-id="element-180" />,
    text: 'Te preocupa un familiar'
  }, {
    icon: <ShieldCheck className="w-6 h-6 text-azul" data-id="element-181" />,
    text: 'Necesitas orientación seria y confidencial'
  }];
  return <section className="py-16 md:py-24 bg-graySoft" data-id="element-182">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-183">
        <h2 className="text-2xl md:text-3xl font-bold text-azul mb-6" data-id="element-184">
          Cuando alguien cercano necesita ayuda, saber por dónde empezar puede
          ser difícil
        </h2>
        <p className="text-lg text-gray-700 mb-12 leading-relaxed" data-id="element-185">
          Cuando una persona enfrenta una dependencia al alcohol o las drogas,
          la familia muchas veces vive preocupación, incertidumbre y miedo a
          tomar una mala decisión. En esos momentos, recibir orientación clara y
          humana puede marcar una diferencia importante para dar el primer paso.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-186">
          {cards.map((card, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 flex flex-col items-center text-center" data-id="element-187">
              <div className="w-12 h-12 bg-celeste-light rounded-full flex items-center justify-center mb-4" data-id="element-188">
                {card.icon}
              </div>
              <p className="font-medium text-gray-800" data-id="element-189">{card.text}</p>
            </div>)}
        </div>
      </div>
    </section>;
}